<template>
  <page-view title="我的待办">
    <a-card class="mb-3">
      <a-form-model class="exi_form v2"
                    ref="form" :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
        <a-form-model-item label='标题' style="width: 600px">
          <a-input v-model="queryForm.title"/>
        </a-form-model-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button style="margin-left: 8px" @click="reset()">重置</a-button>
        <!--                <a-button v-if="isManager" style="margin-left: 8px" @click="onTheOneApprove()" :loading="loading">一键审批</a-button>-->
        <a-popconfirm v-if="isManager" placement="bottom" style="margin-left: 8px"
                      title="是否确认执行此操作?当前功能只针对选取专家流程的领导审批起效" @confirm="onTheOneApprove()">
          <a-button :loading="loading">一键审批</a-button>
        </a-popconfirm>
        <a-popconfirm v-if="isManager" placement="bottom" style="margin-left: 8px"
                      title="是否确认执行此操作?当前功能只针对选取专家流程的领导审批起效" @confirm="onTheOneReturn()">
          <a-button :loading="rLoading">一键退回</a-button>
        </a-popconfirm>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table
          v-if="!isManager"
          ref="table"
          :columns="columns"
          :data="loadData"
          :pagination="pagination"
          :rowKey="record => record.caseId">
        <template slot="title" slot-scope="record">
          <a @click="onView(record)">{{ record.title }}</a>
        </template>
        <template slot="xwfstage" slot-scope="record">
          <div v-html="record.hint"></div>
        </template>
      </s-table>
      <s-table
          v-if="isManager"
          ref="table"
          :columns="columns"
          :data="loadData"
          :pagination="pagination"
          :rowKey="record => record.caseId"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,getCheckboxProps:getCheckboxProps}">
        <template slot="title" slot-scope="record">
          <a @click="onView(record)">{{ record.title }}</a>
        </template>
        <template slot="xwfstage" slot-scope="record">
          <div v-html="record.hint"></div>
        </template>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table/'
import qs from 'qs'

export default {
  name: 'ClaimIndex',
  components: {
    PageView,
    STable
  },
  mounted () {
    this.onFetch()
  },
  created () {
    this.user = this.$ls.get('user')
    // this.isManager = (this.user.roles['system.manage'])
    this.isManager = false
  },
  data () {
    return {
      user: {},
      selectedRowKeys: [],
      isManager: false,
      selIds: [],
      columns: [
        { title: '类别', width: '200px', dataIndex: 'cateName' },
        { title: '项目名称', scopedSlots: { customRender: 'title' } },
        { title: '办理阶段', scopedSlots: { customRender: 'xwfstage' } },
        { title: '送件人', width: '200px', dataIndex: 'createUser' },
        { title: '送件时间', width: '200px', dataIndex: 'createDateAgo' }
      ],
      loading: false,
      rLoading: false,
      queryForm: {
        title: null
      },
      queryParam: {},
      total: '',
      pagination: {
        showTotal: total => `共 ${this.total} 条`
      },
      loadData: parameter => {
        return this.$http.get('/api/1/workflow/tasks.json', {
          params: Object.assign(parameter, this.queryParam),
          paramsSerializer: function (params) {
            return qs.stringify(params, { indices: false })
          }
        }).then(res => {
          if (res.page) {
            this.total = res.page.total
          }
          return res
        })
      }
    }
  },
  methods: {
    onFetch (params = {}) {
      let that = this
      this.loading = true
      this.$http.get('/api/1/workflow/tasks.json', {
        params: params,
        paramsSerializer: function (params) {
          return qs.stringify(params, { indices: false })
        }
      }).then(function (response) {
        that.loading = false
        that.data = response.result
      })
    },
    reset () {
      this.queryForm = {}
      this.queryParam.title = ''
      this.selectedRowKeys = []
      this.$refs.table.refresh(true)
    },
    onSearch () {
      if (this.queryForm.title != null) {
        this.queryParam.title = this.queryForm.title
      } else {
        this.queryParam.title = ''
      }
      this.selectedRowKeys = []
      this.$refs.table.refresh()
    },
    onView (record) {
      let url = record.viewUrl + '?ifWF=1&id=' + record.caseId
      this.$router.push({ path: url })
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getCheckboxProps (record) {
      return {
        props: {
          disabled: this.selIds.some(item => item.id === record.id)
        }
      }
    },
    onTheOneApprove () {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选择需要批量审批的待办办件！')
      }
      var ids = this.selectedRowKeys.join(',')
      let data = {}
      data.ids = ids

      let that = this
      that.loading = true
      this.$http.post('/api/v2/workflow/once_handle_task.json', qs.stringify(data)).then(function (resp) {
        that.loading = false
        if (resp.code !== 200) {
          that.$message.error('操作失败!')
          return
        }
        that.$message.success('操作成功')
        that.onSearch()
      })
    },
    onTheOneReturn () {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选择需要批量审批的待办办件！')
      }
      var ids = this.selectedRowKeys.join(',')
      let data = {}
      data.ids = ids

      let that = this
      that.rLoading = true
      this.$http.post('/api/v2/workflow/once_return_task.json', qs.stringify(data)).then(function (resp) {
        that.rLoading = false
        if (resp.code !== 200) {
          that.$message.error('操作失败!')
          return
        }
        that.$message.success('操作成功')
        that.onSearch()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}
</style>
